import React, { Component } from 'react';
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class InputDefecto extends Component {
    constructor(props) {
        super(props);
        this.changeInput = this.changeInput.bind(this);
    }

    changeInput(event) {
        this.props.changeInput(this.props.referencia, event.target.value)
    }

    render() {
        let { data, form, maxLength, visible, pattern, message, referencia, errorContainer } = this.props;
        let getFieldProps = form.getFieldProps;
        let getFieldError = form.getFieldError;
        let value = data[referencia];
        let visibilidad = visible ? "" : "enabled"
        let me = this;

        return (
            <div className="col-xs-2">
                <GenericInputValidate
                    getFieldProps={getFieldProps(referencia, {
                        onChange(e) {
                            if (pattern) {
                                if (pattern.test(e.target.value) || e.target.value.replace(/\s/g, "") == "") {
                                    me.changeInput(e);
                                }
                            }
                        },
                        rules: [{
                            required: true,
                            pattern: { pattern },
                            message: { message }
                        }]
                    })}
                    id={referencia}
                    name={referencia}
                    value={value}
                    className="form-control default-input"
                    maxLength={maxLength}
                    disabled={visibilidad}
                />
                {errorContainer}
            </div>
        );
    }
};

export default InputDefecto;